var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAprovadorAutorizado)?_c('usuario-fornecedor-aprovador-autorizado-form',{attrs:{"somente-leitura":_vm.somenteLeitura,"is-conversao":_vm.isConversao}}):(_vm.isRepresentanteLegal)?_c('usuario-fornecedor-representante-legal-form',{attrs:{"somente-leitura":_vm.somenteLeitura,"is-conversao":_vm.isConversao}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }